// import axios from "axios";

// const api = axios.create({
//   baseURL: "https://manage.devexa.af/accounts/",
//   timeout: 10000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Automatically add token if present
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Token ${token}`;
//   }
//   return config;
// });

// export default api;


import axios from "axios";

const api = axios.create({
  // baseURL: "http://127.0.0.1:8000/accounts/",
  baseURL: "https://manage.devexa.af/accounts/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically add token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export default api;
